import { Action } from 'redux';

export const GET_SLIDER_IMAGE = 'system-admin/GET_SLIDER_IMAGE';
export const SET_SLIDER_IMAGE = 'system-admin/SET_SLIDER_IMAGE';

export const UPLOAD_SLIDER = 'system-admin/UPLOAD_SLIDER';

export interface UploadSliderAction extends Action<typeof UPLOAD_SLIDER>, OnCompleteAction {
  readonly payload: SliderImageUpload;
}
export const UploadSlider = (data: SliderImageUpload, onComplete?: () => void): UploadSliderAction => ({
  meta: {
    onComplete,
  },
  payload: data,
  type: UPLOAD_SLIDER,
});

export const getSliderImage = () => ({
  type: GET_SLIDER_IMAGE,
});

export const setSliderImages = (data: ReadonlyArray<SliderImages>) => ({
  type: SET_SLIDER_IMAGE,
  payload: data,
});

export interface SetSliderImageAction extends Action<typeof SET_SLIDER_IMAGE> {
  payload: ReadonlyArray<SliderImages>;
}

export const SET_SLIDER_IMAGE_STATUS = 'system-admin/SET_SLIDER_IMAGE_STATUS';

export type SliderImagesStatus = 'idle' | 'loading' | 'success' | 'error';

export const setSliderImagesStatus = (status: SliderImagesStatus) => ({
  type: SET_SLIDER_IMAGE_STATUS,
  payload: status,
});

export interface SetSliderImageStatusAction extends Action<typeof SET_SLIDER_IMAGE_STATUS> {
  payload: SliderImagesStatus;
}

export const GET_SYSTEM_TESTS = 'system-admin/GET_SYSTEM_TESTS';
export const getSystemTest = (user: string) => ({
  type: GET_SYSTEM_TESTS,
  payload: user,
});

export const SET_SYSTEM_TESTS = 'system-admin/SET_SYSTEM_TESTS';
export const setSystemTest = (data: ReadonlyArray<SystemTest>) => ({
  type: SET_SYSTEM_TESTS,
  payload: data,
});
export interface SetSystemTestAction extends Action<typeof SET_SYSTEM_TESTS> {
  payload: ReadonlyArray<SystemTest>;
}
//superadmin run setup test
export const SUPER_GET_SYSTEM_TESTS = 'system-admin/SUPER_GET_SYSTEM_TESTS';
export const getSuperSystemTest = (user: string) => ({
  type: SUPER_GET_SYSTEM_TESTS,
  payload: user,
});

export const SUPER_SET_SYSTEM_TESTS = 'system-admin/SUPER_SET_SYSTEM_TESTS';
export const setSuperSystemTest = (data: any) => ({
  type: SUPER_SET_SYSTEM_TESTS,
  payload: data,
});
export interface SetSuperSystemTestAction extends Action<typeof SUPER_SET_SYSTEM_TESTS> {
  payload: ReadonlyArray<SystemTest>;
}
//super admin capture
export const SUPER_GET_CAPTURE = 'system-admin/SUPER_GET_CAPTURE';
export const getSuperCapture = (user: string) => ({
  type: SUPER_GET_CAPTURE,
  payload: user,
});

export const SUPER_SET_CAPTURE = 'system-admin/SUPER_SET_CAPTURE';
export const setSuperCapture = (data: any) => ({
  type: SUPER_SET_CAPTURE,
  payload: data,
});
export interface SetSuperCaptureTestAction extends Action<typeof SUPER_SET_CAPTURE> {
  payload: ReadonlyArray<Capturepayments>;
}
export const OPEN_RECAPTURE_MODAL = 'system-admin/OPEN_RECAPTURE_MODAL';
export const HIDE_RECAPTURE_MODAL = 'system-admin/HIDE_RECAPTURE_MODAL';
export const openCaptureModal = () => {
  return {
    type: OPEN_RECAPTURE_MODAL,
  };
};
export const hideCaptureModal = () => {
  return {
    type: HIDE_RECAPTURE_MODAL,
  };
};

export interface OpenCaptureModalAction extends Action<typeof OPEN_RECAPTURE_MODAL> {}
export interface HideCaptureModalAction extends Action<typeof HIDE_RECAPTURE_MODAL> {}

//finalcaputre start
export const SUPER_GET_FINAL_CAPTURE = 'system-admin/SUPER_GET_FINAL_CAPTURE';
export const getSuperFinalCapture = (user: any) => ({
  type: SUPER_GET_FINAL_CAPTURE,
  payload: user,
});

export const SUPER_SET_FINAL_CAPTURE = 'system-admin/SUPER_SET_FINAL_CAPTURE';
export const setSuperFinalCapture = (data: any) => ({
  type: SUPER_SET_FINAL_CAPTURE,
  payload: data,
});
export interface SetSuperFinalCaptureTestAction extends Action<typeof SUPER_SET_FINAL_CAPTURE> {
  payload: ReadonlyArray<any>;
}
//finalcaputre end

export type SuperSyatemAdmin =
  | SetSliderImageAction
  | SetSliderImageStatusAction
  | SetSystemTestAction
  | SetSuperCaptureTestAction
  | OpenCaptureModalAction
  | HideCaptureModalAction
  | SetSuperFinalCaptureTestAction
  | SetSuperSystemTestAction;
